import React from 'react';
import { Button, Tooltip } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

type Props = {
    text: string;
    handleClick: () => void;
};

export const RemoveButton: React.FC<Props> = ({ text, handleClick }: Props) => (
    <>
        <Tooltip title={'Remove selected prospects'} placement="top" arrow>
            <Button
                className="button"
                startIcon={<DeleteIcon fontSize="small" htmlColor="#6B7985" />}
                onClick={handleClick}
            >
                {text}
            </Button>
        </Tooltip>
    </>
);
